import "core-js/modules/es6.function.name";
var getters = {
  sidebar: function sidebar(state) {
    return state.app.sidebar;
  },
  device: function device(state) {
    return state.app.device;
  },
  token: function token(state) {
    return state.user.token;
  },
  avatar: function avatar(state) {
    return state.user.avatar;
  },
  name: function name(state) {
    return state.user.name;
  },
  userId: function userId(state) {
    return state.user.userId;
  },
  roleCode: function roleCode(state) {
    return state.user.roleCode;
  },
  userInfo: function userInfo(state) {
    return state.user.userInfo;
  }
};
export default getters;